"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSurveyMarketRequestToJSON = exports.CreateSurveyMarketRequestFromJSONTyped = exports.CreateSurveyMarketRequestFromJSON = exports.instanceOfCreateSurveyMarketRequest = void 0;
/**
 * Check if a given object implements the CreateSurveyMarketRequest interface.
 */
function instanceOfCreateSurveyMarketRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "experimentId" in value;
    isInstance = isInstance && "market" in value;
    return isInstance;
}
exports.instanceOfCreateSurveyMarketRequest = instanceOfCreateSurveyMarketRequest;
function CreateSurveyMarketRequestFromJSON(json) {
    return CreateSurveyMarketRequestFromJSONTyped(json, false);
}
exports.CreateSurveyMarketRequestFromJSON = CreateSurveyMarketRequestFromJSON;
function CreateSurveyMarketRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'experimentId': json['experiment_id'],
        'market': json['market'],
    };
}
exports.CreateSurveyMarketRequestFromJSONTyped = CreateSurveyMarketRequestFromJSONTyped;
function CreateSurveyMarketRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'experiment_id': value.experimentId,
        'market': value.market,
    };
}
exports.CreateSurveyMarketRequestToJSON = CreateSurveyMarketRequestToJSON;
